<template>
  <v-list-item-content :class="contentClass">
    <v-list-item-title>
      <div class="u-name-chat">
        {{ message.user_name || '?' }}
      </div>
      <small style="float: right;">
        {{ formattedDate }} - {{ formattedTime.slice(0, -3) }}
      </small>
    </v-list-item-title>
    <v-list-item-subtitle v-if="message.message_type === 'image'">
      <v-img
        :src="message.message"
        width="100px"
        height="100px"
        @click="expandImage"
      ></v-img>
    </v-list-item-subtitle>
    <v-list-item-subtitle v-else-if="message.message_type === 'video'">
      <div class="video-container">
        <video :id="message.id" ref="videoPlayer" controls preload="auto">
          <source :src="message.message" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </v-list-item-subtitle>
    <v-list-item-subtitle v-else-if="message.message_type === 'file'">
      <v-btn
        class="px-0"
        color="#eef2f6"
        text
        @click="downloadFile(message.message)"
      >
        <v-icon>mdi-file-download-outline</v-icon>
        {{ message.message.split('/').pop() }}
      </v-btn>
    </v-list-item-subtitle>
    <v-list-item-subtitle v-else class="no-ellipsis">{{
      message.message
    }}</v-list-item-subtitle>

    <v-dialog v-model="imageModal" scrollable max-width="800px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="imageModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-img
            :src="message.message"
            contain="contain"
            width="100%"
            height="100%"
          ></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-list-item-content>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    message: Object,
    isUserLogged: Boolean,
  },
  data() {
    return {
      imageModal: false,
    };
  },
  computed: {
    ...mapGetters('Auth', ['user']),
    contentClass() {
      return this.isUserLogged
        ? 'chat-content-logged-user'
        : 'chat-content-another-user';
    },
    formattedDate() {
      return new Date(this.message.created_at).toLocaleDateString({
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    formattedTime() {
      return new Date(this.message.created_at).toLocaleTimeString({
        hour: '2-digit',
        minute: '2-digit',
        second: undefined,
      });
    },
  },
  methods: {
    expandImage() {
      this.imageModal = true;
    },
    downloadFile(url) {
      window.open(url, '_blank');
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
<style lang="scss" scoped>
.v-list-item__content {
  border-radius: 6px;
  padding: 16px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 6px;

  .date-time {
    font-size: 10px;
    margin-top: 8px;
  }

  .v-image {
    cursor: pointer;
    border-radius: 6px !important;
    width: 100% !important;
    height: 200px !important;
  }

  .video-container {
    width: 100%;
    height: 300px;
    overflow: hidden;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .v-list-item__subtitle {
    margin-top: 8px;
    &.no-ellipsis {
      white-space: pre-wrap;
      overflow: visible;
      text-overflow: unset;
    }
  }
  &.chat-content-logged-user {
    background-color: #48b38b;
    color: white !important;
    border-bottom-right-radius: 0px !important;
    border-bottom-left-radius: 6px !important;

    .v-list-item__title {
      color: white !important;

      .u-name-chat {
        font-weight: bold;
        width: 45%;
        overflow: hidden;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .v-list-item__subtitle {
      color: white !important;
    }
  }

  &.chat-content-another-user {
    background-color: #e3e8ef;
  }
}
</style>
